import {createContext} from "react";
import Page from "../../../api/Page";
import QRCodeStyle from "../../../api/qr-code/style/QRCodeStyle";
import GetListQuery from "../../../api/qr-code/style/GetListQuery";
import CreateAndPutPayload from "../../../api/qr-code/style/CreateAndPutPayload";

type QRCodeStyleContextType = {
    data: Page<QRCodeStyle> | undefined;
    setData: (data: Page<QRCodeStyle>) => void;

    /**
     * Update the query and reload the data
     * @since 0.1.9
     * @author Kacper Faber
     */
    setQuery: (query: GetListQuery) => void;

    /**
     * Query
     * @author Kacper Faber
     * @since 0.1.9
     */
    query: GetListQuery;

    /**
     * Reload the context data.
     * @since 0.1.9
     * @author Kacper Faber
     */
    reload: () => void;

    /**
     * Create new QRCodeStyle, refresh the state and returns as promise.
     * @since 0.1.9
     * @author Kacper Faber
     */
    create: (payload: CreateAndPutPayload) => Promise<QRCodeStyle>;
};

/**
 * Throws not implemented error.
 * To use by default in methods.
 * @return never
 * @since 0.1.9
 * @author Kacper Faber
 */
const notImplemented = () => {
    throw new Error('Not implemented');
}

/**
 * Default query
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaultQuery: GetListQuery = {};

/**
 * Default value for context
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaults: QRCodeStyleContextType = {
    data: undefined,
    query: defaultQuery,
    setQuery: notImplemented,
    setData: notImplemented,
    reload: notImplemented,
    create: notImplemented
}

/**
 * Context to hold styles between the components.
 * @since 0.1.9
 * @author Kacper Faber
 */
const ctx = createContext(defaults);

export default ctx;